"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
exports.toastConfigure = () => {
    react_toastify_1.toast.configure();
};
/**
 * ERROR CLEANER (WIP)
 * @param {ApolloError}    error    The ApolloError to format
 */
const cleanError = (error) => {
    // TODO: handle errors better
    let message = '';
    console.log(error.graphQLErrors);
    if (error.graphQLErrors) {
        console.log(error.graphQLErrors);
        let msg;
        if (error.graphQLErrors.length > 0) {
            msg = JSON.parse(JSON.stringify(error.graphQLErrors[0].message));
        }
        else {
            msg = JSON.parse(JSON.stringify(error.graphQLErrors));
        }
        message = msg.message ? msg.message : (msg && msg.length > 0 ? msg : "An unknown error occurred. Please check your internet connection.");
    }
    else {
        message = error.message ? error.message : "An unknown error occurred. Please check your internet connection.";
    }
    const noQL = message.replace('GraphQL error: ', '');
    return noQL;
};
/**
 * ERROR LOGGER
 * @param {string | ApolloError}    message    The message to display. If it is an ApolloError it will be formatted.
 * @param {string}                  title      An optional title. Defaults to 'Error'.
 * @param {boolean}                 showToast  Optional. Displays a toast notification if set to true. Defaults to false
 */
exports.presentError = (message, title = 'Error', showToast = false) => {
    console.log(message, title);
    const displayError = typeof message === 'string' ? message : cleanError(message);
    if (showToast) {
        react_toastify_1.toast(message, { type: react_toastify_1.toast.TYPE.ERROR });
    }
    else {
        sweetalert2_1.default.fire(title, displayError, "error");
    }
};
/**
 * Success LOGGER
 * @param {string}    message    The message to display.
 * @param {string}    title      An optional title. Defaults to 'Success'.
 * @param {boolean}   showToast  Optional. Displays a toast notification if set to true. Defaults to true
 */
exports.presentSuccess = (message, title = 'Success', showToast = true) => {
    console.log(message, title);
    if (showToast) {
        react_toastify_1.toast('✓  ' + message, { type: react_toastify_1.toast.TYPE.INFO });
    }
    else {
        sweetalert2_1.default.fire(title, message, "success");
    }
};
//# sourceMappingURL=alert.js.map